export default "__VITE_ASSET__BQtv9gJt__"